<div class="dialog-main-container">
  <div class="dialog-header">
    <h3 class="h3-semibold">Change illustration</h3>
    <img [src]="iconService.Icon.cross" width="20" height="20" (click)="closeDialog()" />
  </div>
  <div class="illustrations">
    <img class="illustration" agTooltipV2 [agTooltipBody]="illustration.Title" [ngClass]="{ selected: selectedIllustration.Url === illustration.Url }" *ngFor="let illustration of illustrationData" [src]="illustration.Url" (click)="selectIllustration(illustration)" />
  </div>
  <div class="dialog-footer">
    <ag-button-v2 type="tertiary" label="Cancel" (click)="closeDialog()"></ag-button-v2>
    <ag-button-v2 label="Save" [disabled]="selectedIllustration.Url === '' || selectedIllustration.Url === chosenIllustration.Url" (click)="save()" specificWidth="184px"></ag-button-v2>
  </div>
</div>
